"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchUser = fetchUser;
var _auth = _interopRequireDefault(require("./auth"));
var defaultUserEndpoint = "/user/me";
function fetchUser(endpoint) {
  return (0, _auth.default)(endpoint !== null && endpoint !== void 0 ? endpoint : defaultUserEndpoint);
}